module.exports = __webpack_public_path__ + "241fa88ba7af5aed3c574cbd9f28fc54.svg";